<script setup>
import { onBeforeMount, onMounted, ref } from 'vue';


const emit = defineEmits(['resetCartState']);
const modalRef = ref(null);

const onModalHidden = () => {
  emit('resetCartState');
};

onMounted(() => {
  if(modalRef.value) {
    modalRef.value.addEventListener('hidden.bs.modal', onModalHidden);
  }
});

onBeforeMount(() => {
  if(modalRef.value) {
    modalRef.value.removeEventListener('hidden.bs.modal', onModalHidden);
  }
});
</script>

<template>
  <div ref="modalRef" class="modal com_modal2 fade" id="orderErrorModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <img src="/front/assets/common/img/icon_attention1.png" alt="" class="icon_attention1">
          <h3 class="com_fs18 com_strong1 com_center1 com_mgb0">発注できない商品が含まれています</h3>
          <p class="com_fs14 com_center1 com_mgb0">発注内容を修正してください</p>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn com_btn2 wd1" data-bs-dismiss="modal">カートに戻る</button>
        </div>
      </div>
    </div>
  </div>
</template>
